<template lang="html">
    <div class="page" id="ProLessonSettings">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Duration and Pricing</h2>
                <ul class="links">
                    <li>
                        <a
                            class="cancel"
                            @click.prevent="goToLocation({ name: 'proLessonDiary' })"
                            href="#"
                        >
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <span class="info mb10">
                Add the preferred lesson duration you would like to highlight to players when
                booking.
            </span>

            <form class="form3" @submit.prevent="updateSettings">
                <div class="formGroup">
                    <button
                        v-if="!durationOpen"
                        @click.prevent="openDuration"
                        class="button dark left arrowRight"
                        type="button"
                        name="button"
                    >
                        Add Lesson duration <img src="@/assets/arrow-right-white-white.svg" />
                    </button>

                    <span class="select" v-else>
                        <select
                            :class="{ selected: form.lesson_duration }"
                            ref="duration"
                            v-model="form.lesson_duration"
                            required
                        >
                            <option value="">Add lesson duration</option>
                            <option value="15">15 minutes</option>
                            <option value="30">30 minutes</option>
                            <option value="45">45 minutes</option>
                            <option value="60">60 minutes</option>
                            <option value="90">90 minutes</option>
                            <option value="120">120 minutes</option>
                        </select>
                        <img class="arrow" src="@/assets/arrow-right-white.svg" />
                    </span>
                </div>

                <span class="info mb10">
                    1 lesson credit = 15 minutes of your time. Please set the value of 1 credit that
                    will be used as a multiplier for your preferred lesson duration price.
                </span>

                <span class="info tip mb10" id="accordian">
                    <span class="title">Credit value example</span><br />
                    <a href="" @click.prevent="accordianOpen = !accordianOpen"
                        ><chevron-up-icon v-if="accordianOpen" class="icon" /><chevron-down-icon
                            v-else
                            class="icon"
                    /></a>

                    <span class="content" v-if="accordianOpen">
                        <br />
                        1 lesson credit = 15 minutes at a value of
                        {{ $store.state.user.currencySymbol }}{{ form.lesson_price / 100 }}.
                        Therefore 2 credits = 30 minutes at {{ $store.state.user.currencySymbol
                        }}{{ (form.lesson_price / 100) * 2 }}<br />
                        3 credits = 45 mins at {{ $store.state.user.currencySymbol
                        }}{{ (form.lesson_price / 100) * 3 }} and so on.
                    </span>
                </span>

                <div class="formGroup">
                    <button
                        v-if="!priceOpen"
                        @click.prevent="priceOpen = true"
                        class="button dark left arrowRight"
                        type="button"
                        name="button"
                    >
                        Add Lesson price <img src="@/assets/arrow-right-white-white.svg" />
                    </button>
                    <span class="select" v-else>
                        <currency-input
                            :class="{ selected: form.lesson_price }"
                            ref="price"
                            :value-as-integer="true"
                            class="currencyInput"
                            required
                            maxlength="6"
                            v-model="form.lesson_price"
                            :currency="$store.state.user.currency"
                            placeholder="Add value of 1 credit"
                            style="background: white"
                        />
                        <img class="arrow" src="@/assets/arrow-right-white.svg" />
                    </span>
                </div>

                <div class="formGroup">
                    <button :disabled="form.busy" class="button" type="submit" name="button">
                        {{ form.busy ? "Please wait..." : "Save settings" }}
                    </button>
                </div>
            </form>

            <empty-placeholder class="mt30 mb10 warning">
                IMPORTANT: This setting will create the duration and value of 1 lesson credit for
                your booking system. It MUST be completed for the system to allow lesson bookings.
            </empty-placeholder>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import { XIcon, ChevronUpIcon, ChevronDownIcon } from "vue-feather-icons";
import { Form } from "vform";
export default {
    name: "manage-diary",
    components: { EmptyPlaceholder, XIcon, FadeImage, ChevronUpIcon, ChevronDownIcon },
    data() {
        return {
            durationOpen: false,
            priceOpen: false,
            prefferedDurationOpen: false,
            accordianOpen: false,
            form: new Form({
                lesson_duration: "",
                lesson_price: 0,
                preffered_lesson_duration: 15,
                video_lessons_enabled: false,
                video_lessons_price: null,
            }),
        };
    },
    created() {
        this.getSettings();
    },
    methods: {
        openDuration() {
            this.durationOpen = true;
            this.$nextTick(() => {
                this.$refs.duration.focus();
            });
        },
        openPrice() {
            this.priceOpen = true;
            this.$nextTick(() => {
                this.$refs.price.focus();
            });
        },
        openPrefferedDuration() {
            this.prefferedDurationOpen = true;
            this.$nextTick(() => {
                this.$refs.pref_duration.focus();
            });
        },
        goToLocation($url) {
            if (this.$route.query.from) {
                this.$router.go(-1);
            } else {
                this.$router.push($url);
            }
        },
        getSettings() {
            this.form.get("/settings").then((response) => {
                if (response.data) {
                    this.form.fill(response.data);
                    if (response.data.lesson_duration) {
                        this.durationOpen = true;
                    }
                    if (response.data.lesson_price) {
                        this.priceOpen = true;
                    }

                    if (!response.data.preffered_lesson_duration) {
                        this.form.preffered_lesson_duration = 15;
                    }
                }
            });
        },
        updateSettings() {
            this.form.post("/settings").then(() => {
                this.$notify({
                    text: "Your lesson settings have been updated",
                });
            });
        },
    },
};
</script>

<style lang="scss">
#ProLessonSettings {
    .formGroup {
        margin-bottom: 10px;
        .arrow {
            position: absolute;
            right: 17px;
            top: 5px;
            pointer-events: none;
        }
    }
    #accordian {
        position: relative;
        .title {
            font-size: 16px;
        }
        a {
            position: absolute;
            top: 0px;
            right: 0px;
            padding: 11px;
            padding-top: 15px;
            padding-bottom: 6px;
            .icon {
                color: #267962;
            }
        }
    }
}
</style>
